import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PurchaseHistoryComponent } from "@onsip/web/features/accountSettings/purchaseHistory/purchase-history.component";

const routes: Routes = [{ path: "", component: PurchaseHistoryComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: []
})
export class PurchaseHistoryRoutingModule {}
